import axios from 'axios';

export default {
  async getSiteWorkerListReport(siteId) {
    return await axios({
      url: '/api/tenant/report/site-worker-list/' + siteId,
      responseType: 'blob',
    }).then(r => r.data);
  },
  async getSiteDaybookReport(siteId, startDate, endDate, workIds) {
    return await axios({
      url: `/api/tenant/report/site-daybooks/${siteId}`,
      params: { startDate, endDate, workIds: (workIds && workIds.length) ? workIds.join(',') : undefined },
      responseType: 'blob',
    }).then(r => r.data);
  },
  async getSiteWorkerIntroReport(siteId) {
    return await axios({
      url: 'api/tenant/report/introduction/' + siteId,
      method: 'GET',
      responseType: 'blob',
    }).then(r => r.data);
  },
  async getWorkerTimeEntriesReport(userId, startDate, endDate) {
    const params = { startDate, endDate };
    if (userId) params.userId = userId;
    return await axios({
      url: '/api/tenant/report/worker-timeentries',
      params,
      responseType: 'blob',
    }).then(r => r.data);
  },
  async getLeaveCalendarData(startDate, endDate) {
    return await axios({
      url: '/api/tenant/report/leave-calendar/data',
      params: { startDate, endDate },
    }).then(r => r.data);
  },
  async getLeaveCalendarReport(startDate, endDate) {
    return await axios({
      url: '/api/tenant/report/leave-calendar',
      params: { startDate, endDate },
      responseType: 'blob',
    }).then(r => r.data);
  },
  async getLeaveCalendarXlsx(startDate, endDate) {
    return await axios({
      url: '/api/tenant/report/leave-calendar/xlsx',
      params: { startDate, endDate },
      responseType: 'blob',
    }).then(r => r.data);
  },
};
